import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RedirectService } from '../redirect/redirect.service';
import { DeviceDetectorService } from './device-detector.service';


declare var $: any;

@Component({
  selector: 'app-device-detector',
  templateUrl: './device-detector.component.html',
  styleUrls: ['./device-detector.component.scss']
})
export class DeviceDetectorComponent implements OnInit {

    public modalOpen: boolean;

    constructor(
        private _deviceDetectorService: DeviceDetectorService,
        private _router: Router,
        private _redirectService: RedirectService,
        private _activatedRoute: ActivatedRoute,
        public activeModal: NgbActiveModal,
    ) { }

  ngOnInit() {
    this._deviceDetectorService.modal.subscribe((isOpen) => {
        console.log('i received to open modal ?', isOpen);
        this.modalOpen = isOpen as boolean;
    });
  }
  closeModal() {
    this._deviceDetectorService.close();
}


}



// WEBPACK FOOTER //
// ./src/app/device-detector/device-detector.component.ts